import { i18n } from '@/plugins/i18n'
import { invertKeyValues } from '@/common/objects'
import { StoreUserRelationStatus } from '@/constants'


export const statusStr = (status) => {
    const statusStr = invertKeyValues(StoreUserRelationStatus)[status]

    return statusStr ? i18n.t(`publisher.statuses.${statusStr.toLowerCase()}`) : 'undefined'
}

export const btnStatusStr = (status) => {
    const statusStr = invertKeyValues(StoreUserRelationStatus)[status]

    return statusStr ? i18n.t(`publisher.btn_statuses.${statusStr.toLowerCase()}`) : 'undefined'
}

export const statusColor = (status) => {
    const colors = {
        [StoreUserRelationStatus.PENDING]: 'warning',
        [StoreUserRelationStatus.ACTIVE]: 'success',
        [StoreUserRelationStatus.BLOCKED]: 'danger',
        [StoreUserRelationStatus.REJECTED]: 'danger',
        [StoreUserRelationStatus.STOP_BY_PUBLISHER]: 'danger',
    }

    return colors[status]
}

export const countdown = (store_user) => {
    if(store_user.status !== StoreUserRelationStatus.BLOCKED) {
        return false;
    }

    let tomorrow = new Date(store_user.relation_updated_at)
    tomorrow.setHours( tomorrow.getHours() + 24 )

    return {
        startAt: store_user.relation_updated_at,
        endAt: tomorrow
    }
}

export const checkCanActiveBlockedPublisher = (store_user) => {
    let limitation = new Date(store_user.relation_updated_at)
    limitation.setHours( limitation.getHours() + 1 )

    return limitation > new Date
}
